<ng-template #disabledSelector>
  <ibk-select disabled class="field"></ibk-select>
</ng-template>
<!-- <p>
  <b>
    Direcci&oacute;n legal:
  </b>      
</p> -->
<div class="ba-field-group">
  <ibk-input-group>
    <label>Departamento (*)</label>
    <ibk-select
      class="field"
      dsRxForm="selectChange"
      formControlName="department"
    >
      <ibk-select-option
        *ngFor="let option of department$ | async"
        [value]="option.value"
        [label]="option.label"
      ></ibk-select-option>
    </ibk-select>
  </ibk-input-group>
  <ibk-input-group>
    <label>Provincia (*)</label>
    <ng-container
      *ngIf="provinces$ | async as provinces; else disabledSelector"
    >
      <ibk-select
        class="field"
        dsRxForm="selectChange"
        formControlName="province"
      >
        <ibk-select-option
          *ngFor="let option of provinces"
          [value]="option.value"
          [label]="option.label"
        ></ibk-select-option>
      </ibk-select>
    </ng-container>
  </ibk-input-group>
  <ibk-input-group>
    <label>Distrito (*)</label>
    <ng-container
      *ngIf="districts$ | async as districts; else disabledSelector"
    >
      <ibk-select
        class="field"
        dsRxForm="selectChange"
        formControlName="district"
      >
        <ibk-select-option
          *ngFor="let option of districts"
          [value]="option.value"
          [label]="option.label"
        ></ibk-select-option>
      </ibk-select>
    </ng-container>
  </ibk-input-group>
</div>

<div class="ba-field-group">
  <ibk-input-group>
    <label>Tipo de vía (*)</label>
    <ibk-select
      class="field"
      dsRxForm="selectChange"
      formControlName="streetType"
    >
      <ibk-select-option
        *ngFor="let option of paramsService.params$('streetType') | async"
        [value]="option.value"
        [label]="option.label"
      ></ibk-select-option>
    </ibk-select>
  </ibk-input-group>
  <ibk-input-group class="span-2">
    <label>Nombre de vía (*)</label>
    <ibk-input class="field">
      <input
        class="field"
        [disabled]="form.controls.streetName.disabled"
        formControlName="streetName"
      />
    </ibk-input>
  </ibk-input-group>
</div>

<div class="ba-field-group">
  <ibk-input-group>
    <label>Número (*)</label>
    <ibk-input class="field">
      <input
        class="field"
        [disabled]="form.controls.streetNumber.disabled"
        formControlName="streetNumber"
      />
    </ibk-input>
  </ibk-input-group>
  <ibk-input-group>
    <label>Manzana</label>
    <ibk-input class="field">
      <input
        class="field"
        [disabled]="form.controls.block.disabled"
        formControlName="block"
      />
    </ibk-input>
  </ibk-input-group>
  <ibk-input-group>
    <label>Lote</label>
    <ibk-input class="field">
      <input
        class="field"
        [disabled]="form.controls.lot.disabled"
        formControlName="lot"
      />
    </ibk-input>
  </ibk-input-group>
  <ibk-input-group>
    <label>Interior</label>
    <ibk-input class="field">
      <input
        class="field"
        [disabled]="form.controls.apartment.disabled"
        formControlName="apartment"
      />
    </ibk-input>
  </ibk-input-group>
</div>
